import { isEmpty } from 'lodash'
import { Module } from 'wrapper6'

const $ = jQuery

export default class LanguageSelector extends Module {
  ready (app) {
    this.selector = document.querySelector('.wpml-wrapper')

    if (this.selector) {
      this.submenu = this.selector.querySelector('.wpml-ls-sub-menu')

      if (!this.submenu.innerHTML.trim()) {
        this.selector.querySelector('.wpml-ls-current-language').classList.add('no-languages')
      }
    }
  }
}
